export default function ({ redirect, $cookies }) {
  const strategy = $cookies.get('vx.strategy');
  if (strategy) {
    const token = $cookies.get(`vx.token.${strategy}`);
    if (token) {
      return redirect('/');
    }
  }
}
